import type { PaidBreakExceptionReason } from '#/shared/types/PaidBreakRequest';
import { getHourWord } from '#/shared/utils/dateTimeHelper';

import { PaidBreakExceptionDetails } from './PaidBreakExceptionDetails';

type PaidBreakExceptionPendingContentProps = {
  hours: string;
  reason?: PaidBreakExceptionReason;
  notes?: string;
  subtitle?: string | null;
};

export function PaidBreakExceptionPendingContent({
  hours,
  reason,
  notes,
  subtitle,
}: PaidBreakExceptionPendingContentProps) {
  const hourText = getHourWord(Number(hours));
  const defaultSubtitle =
    subtitle === undefined ? `If accepted, the timesheet will adjust to add ${hours} ordinary ${hourText}.` : subtitle;

  return (
    <>
      {defaultSubtitle && <p className="text-base mb-8 text-on-surface-variant">{defaultSubtitle}</p>}
      <PaidBreakExceptionDetails reason={reason} notes={notes} />
    </>
  );
}
